import leeCoreLexHabitFormationExperiments from 'bundles/epic/clients/leeCoreLexHabitFormation';

export function isUnifiedGoalSettingEnabled() {
  const isUGSGARolloutEnabled = leeCoreLexHabitFormationExperiments.get('unifiedGoalSettingGARolloutEnabled');
  return isUGSGARolloutEnabled || leeCoreLexHabitFormationExperiments.get('unifiedGoalSettingEnabled');
}

export function isDeadlineUxCopyChangeEnabled() {
  return leeCoreLexHabitFormationExperiments.get('deadlineUxCopyChangeEnabled');
}
